import { render, staticRenderFns } from "./advanceExamQuestionSettingsCompenent.vue?vue&type=template&id=97139d86"
import script from "./advanceExamQuestionSettingsCompenent.vue?vue&type=script&lang=js"
export * from "./advanceExamQuestionSettingsCompenent.vue?vue&type=script&lang=js"
import style0 from "./advanceExamQuestionSettingsCompenent.vue?vue&type=style&index=0&id=97139d86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports